module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"vacancy":"Вакансия","step":"Шаг"}}')
  delete Component.options._Ctor
}
